var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcNewLink16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 5.22 14.78 C 5.513 15.072 5.987 15.072 6.28 14.78 L 13.5 7.56 L 13.5 13.25 C 13.5 13.664 13.836 14 14.25 14 C 14.664 14 15 13.664 15 13.25 L 15 5.75 C 15 5.336 14.664 5 14.25 5 L 6.75 5 C 6.336 5 6 5.336 6 5.75 C 6 6.164 6.336 6.5 6.75 6.5 L 12.44 6.5 L 5.22 13.72 C 4.928 14.013 4.928 14.487 5.22 14.78 Z",
    fill: "rgb(108, 114, 132)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNewLink16);
export default __webpack_public_path__ + "static/media/ic_new_link_16.35e87eaf70bbf2a08819868986bbe17a.svg";
export { ForwardRef as ReactComponent };